// extracted by mini-css-extract-plugin
module.exports = {"descriptionContainer":"stake-confirm_descriptionContainer__3ltRR","confirm":"stake-confirm_confirm__2apF3","descriptionItem":"stake-confirm_descriptionItem__1lavi"};